export default {"src":"/_next/static/media/footerLogo2.903b3521.svg","height":31,"width":168,"blurWidth":0,"blurHeight":0};